import { StorageUtil } from '../../../../../shared/utils/storage';
import { LinkedInPlatform } from '../../../../linkedin-automation/enums';

export const cobaltSessionTokenStorageKey = 'cobalt-session-token';

export const setCobaltSessionToken = (token: string) =>
  StorageUtil.setItem(cobaltSessionTokenStorageKey, token);
export const getCobaltSessionToken = () =>
  StorageUtil.getItem(cobaltSessionTokenStorageKey);
export const removeCobaltSessionToken = () =>
  StorageUtil.removeItem(cobaltSessionTokenStorageKey);

export enum CobaltEvent {
  'When a Prospect is Unsubscribed' = 'prospect-unsubscribed',
  'Prospect is Unsubscribed in Saleshandy' = 'prospect-unsubscribed',
  'When a Prospect is Finished' = 'prospect-finished',
  'Prospect is Finished in Saleshandy' = 'prospect-finished',
  'Reply is Received in Saleshandy' = 'reply-received',
  'Link is Clicked in Saleshandy' = 'email-link-clicked',
  'Sequence Email is Opened in Saleshandy' = 'email-opened',
  'Email Sent from Saleshandy' = 'sequence-email-sent',
  'When an Email is Bounced' = 'email-bounced',
  'Email is Bounced in Saleshandy' = 'email-bounced',
  'Conversation Category is Updated in Saleshandy' = 'reply-category-updated',
  'Conversation Category Updated in Saleshandy' = 'reply-category-updated',
  'Prospect Outcome is updated in Saleshandy' = 'reply-category-updated',
  'Prospect Added to Sequence in Saleshandy' = 'prospect-added-to-sequence',
  'Email is Opened in Saleshandy' = 'email-opened',
  'Import Prospects from Salesforce' = 'sync-prospects',
  'Import Prospects from Hubspot' = 'sync-prospects',
}
export const staticOptionsForCategory = [
  {
    key: 'Interested',
    value: 'Interested',
  },
  { key: 'Not Interested', value: 'Not Interested' },
  { key: 'Closed', value: 'Closed' },
  { key: ':Meeting Booked', value: 'Meeting Booked' },
  { key: 'Do Not Contact', value: 'Do Not Contact' },
  { key: 'Out of Office', value: 'Out of Office' },
  { key: 'Not Now', value: 'Not Now' },
];

export enum IntegrationTabs {
  FieldMapping = 'Field Mapping',
  TriggersActivity = 'Triggers & Activity',
  ProspectImport = 'Prospects Import',
  CustomWorkflow = 'Custom Workflow',
  Logs = 'Logs',
}
export const hasConversationCategorySelected = (obj) =>
  Object.values(obj).some((objValue) =>
    staticOptionsForCategory.some((arrItem) => arrItem.value === objValue),
  );

export const cleanPlanName = (planName: string): string =>
  planName
    .replace(/\([^)]*\)/g, '')
    .toLowerCase()
    .trim();

export const LINKEDIN_PLATFORM_TO_SLUG: Record<LinkedInPlatform, string> = {
  [LinkedInPlatform.Aimfox]: 'aimfox',
  [LinkedInPlatform.HeyReach]: 'heyreach',
};

export const SLUG_TO_LINKEDIN_PLATFORM: Record<string, LinkedInPlatform> = {
  aimfox: LinkedInPlatform.Aimfox,
  heyreach: LinkedInPlatform.HeyReach,
};

export const CRM_SLUGS = ['pipedrive', 'zoho', 'hubspot', 'salesforce'] as const;

export const CRM_TAB_TO_SLUG: Record<IntegrationTabs, string> = {
  [IntegrationTabs.FieldMapping]: 'field-mapping',
  [IntegrationTabs.TriggersActivity]: 'triggers-activity',
  [IntegrationTabs.ProspectImport]: 'prospects-import',
  [IntegrationTabs.CustomWorkflow]: 'custom-workflow',
  [IntegrationTabs.Logs]: 'logs',
};

export const SLUG_TO_CRM_TAB: Record<string, IntegrationTabs> = {
  'field-mapping': IntegrationTabs.FieldMapping,
  'triggers-activity': IntegrationTabs.TriggersActivity,
  'prospects-import': IntegrationTabs.ProspectImport,
  'custom-workflow': IntegrationTabs.CustomWorkflow,
  logs: IntegrationTabs.Logs,
};

export const LINKEDIN_TAB_VALUES: ReadonlyArray<'config' | 'field-mapping'> = [
  'config',
  'field-mapping',
];
